import React, { useEffect, useState } from "react";
import axiosInstance from "../../../../services/AxiosInstance";
import Loading from "../components/loading";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { LinkPrimary } from "../components/CitoPlusLink";
import { Badge } from "react-bootstrap";
import FormAgregarActivoZonaSocial from "./FormAgregarActivoZonaSocial";
import NoImagePlaceholder from "../components/NoImagePlaceholder";

const DIAS_SEMANA = ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"];

const formatDiasOperacion = (dias) => {
  if (!dias || dias.length === 0) return "No disponible";
  if (dias.length === 7) return "Todos los días";
  if (JSON.stringify([...dias].sort()) === JSON.stringify([0, 1, 2, 3, 4]))
    return "Lun - Vie";
  return dias.map((d) => DIAS_SEMANA[d]).join(", ");
};

const ESTADO_BADGE_MAP = {
  nuevo: "success",
  bueno: "primary",
  mantenimiento: "warning",
  dado_de_baja: "danger",
};

const ESTADO_LABEL_MAP = {
  nuevo: "Nuevo",
  bueno: "Bueno",
  mantenimiento: "En mantenimiento",
  dado_de_baja: "Dado de baja",
};

export const ZonaSocialDetalle = () => {
  const params = useParams();

  const URL = `/api/v3/zonas-sociales/zonas/${params.uuid}/`;

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});

  const fetchZonaSocial = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(URL);
      const data = await response.data;
      setData(data);
      return data;
    } catch (error) {
      if (error.response) {
        const errorMessages = Object.values(error.response.data).flat();
        const errorMessage = errorMessages.join("\n");
        Swal.fire("Error", errorMessage, "error");
      } else {
        console.error(error);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchZonaSocial();
  }, []);

  const [showModalAddActivo, setShowModalAddActivo] = useState(false);
  const [selectedZonaSocialUUID, setSelectedZonaSocialUUID] = useState(null);
  const [selectedActivoUUID, setSelectedActivoUUID] = useState(null);
  const [editActivo, setEditActivo] = useState(false);

  const handleModalAgregarActivos = (
    zonaSocialUUID,
    activoUUID = null,
    editMode = false,
  ) => {
    setEditActivo(editMode);
    setSelectedZonaSocialUUID(zonaSocialUUID);
    setSelectedActivoUUID(activoUUID);
    setShowModalAddActivo(true);
  };

  if (loading) {
    return (
      <>
        <Loading />
      </>
    );
  }

  return (
    <>
      <div className="d-flex align-items-center mb-4 flex-wrap">
        <h3 className="mb-0 me-auto">Zona Social ({data.nombre})</h3>
      </div>
      <div className="row">
        <div className="col-xl-4 col-xxl-3">
          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                {data.imagen_url ? (
                  <img
                    src={data.imagen_url}
                    alt={data.nombre}
                    className="card-img-top"
                    style={{
                      height: "200px",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <div style={{ height: "200px", overflow: "hidden" }}>
                    <NoImagePlaceholder alt={data.nombre} height="200px" />
                  </div>
                )}
                <div className="card-header border-0 pb-0">
                  <h4 className="fs-20 mb-0">Resumen</h4>
                </div>
                <div className="card-body pt-4">
                  <div className="mb-3 d-flex justify-content-between">
                    <span className="text-muted">Nombre:</span>
                    <span className="fw-semibold">{data.nombre}</span>
                  </div>
                  <div className="mb-3 d-flex justify-content-between">
                    <span className="text-muted">Responsable:</span>
                    <span>{data.responsable}</span>
                  </div>
                  <div className="mb-3 d-flex justify-content-between align-items-center">
                    <span className="text-muted">Tipo de reserva:</span>
                    {data.tipo_reserva === "hora" ? (
                      <Badge bg="info">
                        Por hora ({data.tiempo_maximo_reserva}h máx)
                      </Badge>
                    ) : (
                      <Badge bg="primary">Por día</Badge>
                    )}
                  </div>
                  <div className="mb-3 d-flex justify-content-between">
                    <span className="text-muted">Horario:</span>
                    <span>
                      {data.horario_inicio} - {data.horario_fin}
                    </span>
                  </div>
                  <div className="mb-3 d-flex justify-content-between">
                    <span className="text-muted">Días:</span>
                    <span>{formatDiasOperacion(data.dias_operacion)}</span>
                  </div>
                  <div className="mb-3 d-flex justify-content-between">
                    <span className="text-muted">Capacidad:</span>
                    <span>
                      {data.capacidad_min} - {data.capacidad_max} personas
                    </span>
                  </div>
                  <hr />
                  <div className="mb-3 d-flex justify-content-between">
                    <span className="text-muted">Activo:</span>
                    <Badge bg={data.activo ? "success" : "secondary"}>
                      {data.activo ? "Sí" : "No"}
                    </Badge>
                  </div>
                  <div className="mb-3 d-flex justify-content-between">
                    <span className="text-muted">Reservable:</span>
                    <Badge bg={data.reservable ? "success" : "secondary"}>
                      {data.reservable ? "Sí" : "No"}
                    </Badge>
                  </div>
                  <div className="mb-3 d-flex justify-content-between align-items-center">
                    <span className="text-muted">Aprobación manual:</span>
                    <Badge bg={data.requiere_aprobacion_manual ? "warning" : "secondary"}>
                      {data.requiere_aprobacion_manual ? "Sí" : "No"}
                    </Badge>
                  </div>
                  <div className="mb-3 d-flex justify-content-between">
                    <span className="text-muted">Creado:</span>
                    <small className="text-muted">{data.created_at}</small>
                  </div>
                  <div className="mb-3 d-flex justify-content-between">
                    <span className="text-muted">Actualizado:</span>
                    <small className="text-muted">{data.updated_at}</small>
                  </div>
                </div>
                <div className="card-footer border-0 pt-0">
                  <div className="d-flex justify-content-between flex-wrap gap-2">
                    <LinkPrimary to={`/zona-social/editar/${data.uuid}`}>
                      <i className="fas fa-pencil-alt me-2"></i>
                      Editar
                    </LinkPrimary>
                    <LinkPrimary
                      to={"#"}
                      onClick={() => {
                        handleModalAgregarActivos(data.uuid);
                      }}
                    >
                      <i className="fas fa-plus me-2"></i>
                      Agregar Activo
                    </LinkPrimary>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-8 col-xxl-9">
          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header d-block">
                  <h4 className="fs-20 d-block">{data.nombre}</h4>
                </div>
                <div className="card-body pb-0">
                  {data.descripcion && (
                    <>
                      <h5 className="fs-16 mb-3">
                        <i className="fas fa-align-left me-2"></i>
                        Descripción
                      </h5>
                      <div className="ms-2 mb-3">{data.descripcion}</div>
                      <hr />
                    </>
                  )}

                  {data.reglas_uso && (
                    <>
                      <h5 className="fs-16 mb-3">
                        <i className="fas fa-info-circle me-2"></i>
                        Reglas de Uso
                      </h5>
                      <div
                        className="ms-2 mb-3 p-3 bg-light rounded"
                        dangerouslySetInnerHTML={{ __html: data.reglas_uso }}
                      />
                      <hr />
                    </>
                  )}

                  <h5 className="fs-16 mb-3">
                    <i className="fas fa-boxes me-2"></i>
                    Activos ({data.activos?.length || 0})
                  </h5>
                  {data.activos && data.activos.length > 0 ? (
                    data.activos.map((item, index) => (
                      <div key={item.uuid || index} className="row mb-3 border-bottom pb-3">
                        <div className="col-xl-6">
                          <div className="ms-2">
                            <p className="font-w500 mb-2">
                              <span className="text-muted">Nombre:</span>
                              <span className="fw-semibold ms-2">{item.nombre}</span>
                            </p>
                            <p className="font-w500 mb-2">
                              <span className="text-muted">Cantidad:</span>
                              <span className="ms-2">{item.cantidad}</span>
                            </p>
                            <p className="font-w500 mb-2">
                              <span className="text-muted">Estado:</span>
                              <Badge bg={ESTADO_BADGE_MAP[item.estado] || "secondary"} className="ms-2">
                                {ESTADO_LABEL_MAP[item.estado] || item.estado}
                              </Badge>
                            </p>
                            <p className="font-w500 mb-2">
                              <span className="text-muted">Activo:</span>
                              <Badge bg={item.activo ? "success" : "secondary"} className="ms-2">
                                {item.activo ? "Sí" : "No"}
                              </Badge>
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-6">
                          <div className="ms-2">
                            <p className="font-w500 mb-2">
                              <span className="text-muted">Observaciones:</span>
                              <span className="ms-2">{item.observaciones || "-"}</span>
                            </p>
                            {item.categoria && (
                              <p className="font-w500 mb-2">
                                <span className="text-muted">Categoría:</span>
                                <span className="ms-2">{item.categoria?.nombre || "-"}</span>
                              </p>
                            )}
                            <p className="mb-0">
                              <LinkPrimary
                                to={"#"}
                                onClick={() => {
                                  handleModalAgregarActivos(
                                    null,
                                    item.uuid,
                                    true,
                                  );
                                }}
                              >
                                <i className="fas fa-pencil-alt me-2"></i>
                                Editar
                              </LinkPrimary>
                            </p>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="text-center py-4 text-muted">
                      <i className="fas fa-boxes fa-2x mb-2 d-block"></i>
                      No hay activos registrados
                    </div>
                  )}
                  <div className="d-flex justify-content-between py-4 border-top flex-wrap">
                    <span className="text-muted">
                      Publicado el <strong>{data.created_at}</strong>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <FormAgregarActivoZonaSocial
        showModal={showModalAddActivo}
        onClose={() => {
          setShowModalAddActivo(false);
          setSelectedZonaSocialUUID(null);
          setEditActivo(false);
          setSelectedActivoUUID(null);
        }}
        updateList={fetchZonaSocial}
        selectedZonaSocialUUID={selectedZonaSocialUUID}
        selectedActivoUUID={selectedActivoUUID}
        editMode={editActivo}
      />
    </>
  );
};

export default ZonaSocialDetalle;
